var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimelineScroller = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.0034 5.99963L16.5034 7.49963L12.0034 11.9996L7.50319 7.99963L1.50342 14.4996L4.00339 16.4996L7.50319 12.4996L12.0034 16.4996L19.0034 9.99963L20.5032 11.4996L21.5032 4.99963L15.0034 5.99963Z",
  fill: "#7F7F7F"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 18,
  transform: "translate(11.5 3)",
  fill: "white"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 11.5,
  y: 3,
  width: 1,
  height: 1,
  fill: "#7F7F7F"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 11.5,
  y: 5,
  width: 1,
  height: 1,
  fill: "#7F7F7F"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 11.5,
  y: 7,
  width: 1,
  height: 1,
  fill: "#7F7F7F"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 11.5,
  y: 9,
  width: 1,
  height: 1,
  fill: "#7F7F7F"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 11.5,
  y: 11,
  width: 1,
  height: 1,
  fill: "#7F7F7F"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 11.5,
  y: 13,
  width: 1,
  height: 1,
  fill: "#7F7F7F"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 11.5,
  y: 15,
  width: 1,
  height: 1,
  fill: "#7F7F7F"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 11.5,
  y: 17,
  width: 1,
  height: 1,
  fill: "#7F7F7F"
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  x: 11.5,
  y: 19,
  width: 1,
  height: 1,
  fill: "#7F7F7F"
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  x: 11.5,
  y: 6,
  width: 1,
  height: 1,
  fill: "white"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 11.5,
  y: 10,
  width: 1,
  height: 1,
  fill: "white"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 11.5,
  y: 14,
  width: 1,
  height: 1,
  fill: "white"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: 11.5,
  y: 18,
  width: 1,
  height: 1,
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimelineScroller);
export { ForwardRef as ReactComponent };